export default function Logo({ size = 34 }: { size?: number }) {
  return (
    <span className="flex items-center gap-2.5">
      <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden>
        <defs>
          <linearGradient id="logo-g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#38bdf8" />
            <stop offset="1" stopColor="#0284c7" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.12)" />
        <path d="M32 12 L52 50 L42 50 L32 30 L22 50 L12 50 Z" fill="url(#logo-g)" />
        <path d="M27 50 L32 40 L37 50 Z" fill="#7dd3fc" />
      </svg>
      <span className="font-display text-lg font-bold tracking-tight text-white">
        Apex <span className="gradient-text">Car Care</span>
      </span>
    </span>
  );
}
